import React from 'react'

const stripeStyle = {
  maxWidth: '80rem',
  height: '5px',
  backgroundColor: '#fec601ff'
}

function Stripe() {
  return <div style={stripeStyle}></div>
}

export default Stripe
